import { render } from "./ModalDetalhesProjeto.vue?vue&type=template&id=091024a9&scoped=true"
import script from "./ModalDetalhesProjeto.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesProjeto.vue?vue&type=script&lang=js"

import "./ModalDetalhesProjeto.vue?vue&type=style&index=0&id=091024a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091024a9"]])

export default __exports__